<template>
  <div class="main-content">
    <div class="roll-call-page">
      <div class="container">
        <div class="course-info">
          <div class="course-info__title">{{ branchName }}</div>
          <div class="course-info__date">{{ datePick }}</div>
        </div>
        <div class="course-area">
          <div class="course-area__day">
            <OneCourse
              v-for="(schedule, index) in morningSchedules"
              :key="index"
              :schedule="schedule"
              :date="datePick"
            />
          </div>

          <div class="course-area__night">
            <OneCourse
              v-for="(schedule, index) in eveningSchedules"
              :key="index"
              :schedule="schedule"
              :date="datePick"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import OneCourse from '@/components/RollCallInsideStudent/OneCourse';
import { mapGetters, mapActions } from 'vuex';
import { fetchSchedules } from '@/api/check_in_system';

export default {
  data() {
    return {
      datePick: moment().format('YYYY-MM-DD'),
      // Store the meta element
      viewport_meta: document.getElementById('viewport-meta'),
      // Define our viewport meta values
      viewports: {
        default: 'width=device-width',
        landscape: 'initial-scale=1.0'
      },
      path: this.$route.path,
      morningSchedules: [],
      eveningSchedules: []
    };
  },
  components: {
    OneCourse
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'branchName'])
  },
  created() {
    // 來到這個頁面,viewport設成有手機版的頁面
    this.viewportSet(this.viewport_meta, this.viewports);

    this.fetchSchedules();

    if (this.isLogin) {
      this.fetchInitialData();
    }
  },

  beforeRouteLeave(to, from, next) {
    // 離開這個頁面,viewport設回只有電腦版寬度
    this.viewportSetWideVersion(this.viewport_meta, this.viewports);
    next();
  },

  methods: {
    ...mapActions(['fetchInitialData']),
    viewportSet(viewport_meta, viewports) {
      if (screen.width > 768) {
        viewport_meta.setAttribute('content', viewports.landscape);
      } else {
        viewport_meta.setAttribute('content', viewports.default);
      }
    },
    viewportSetWideVersion(viewport_meta, viewports) {
      viewport_meta.setAttribute('content', viewports.landscape);
    },
    fetchSchedules() {
      fetchSchedules(schedulesSession => {
        this.morningSchedules = schedulesSession['morning'];

        this.eveningSchedules = schedulesSession['evening'];
      });
    }
  }
};
</script>
